import gql from 'not-graphql-tag';

export const getContactDetails = gql`
  query getAccountInfo {
    getAccountInfo {
      contactDetails {
        encryptedContactId
        contactType
        contactValue
        isPrimary
      }
    }
  }
`;
